import * as React from 'react';
import { translation } from '../../../i18n';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { defaultPageable, Pageable } from '../../../api/pageable';
import EmptyPage from '../../../components/emptyPage/EmptyPage';
import { getSelfHistory } from '../questionnaireApi';
import { RouteComponentProps, withRouter } from 'react-router';
import { SELF_HISTORY_ROUTE } from '../../../router/routes';
import AnsweredQuestionnaireList
  from '../../../components/questionnaire/answeredQuestionnaire/AnsweredQuestionnaireList';
import { withAnsweredQuestionnairePage } from '../../../router/Loaders';
import { AnsweredQuestionnaireDto } from '../../answeredQuestionnaireTypes';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type CombinedProps = RouteComponentProps & Props;

@observer
class SelfHistory extends React.Component<CombinedProps> {

  @observable private pageAble: Pageable = defaultPageable();

  constructor(props: CombinedProps) {
    super(props);
    this.props.renderSearch(true);
  }

  public render() {
    return (
      <>
        {
          withAnsweredQuestionnairePage(
            () => getSelfHistory({searchText: this.props.searchText.get()}, this.pageAble),
            'withAnsweredPage' + this.pageAble.page + this.props.searchText,
            answeredQuestionnairePage =>
              <AnsweredQuestionnaireList
                downloadButtonEnabled={true}
                questionnaires={answeredQuestionnairePage}
                handleChangePage={this.handleChangePage}
                onClick={(questionnaireDto: AnsweredQuestionnaireDto) =>
                  this.props.history.push(SELF_HISTORY_ROUTE.selfHistory(questionnaireDto.id).route)}
                emptyPage={
                  <EmptyPage message={translation.t('historyComponent.self.title')}
                             searchText={this.props.searchText.get()}
                             displayFab={false}/>
                }
              />
          )
        }
      </>
    );
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };

}

export default withRouter(SelfHistory);
